webpackJsonp([21],{

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1386);


/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reactIntl = __webpack_require__(7);

var _ja = __webpack_require__(1387);

var _ja2 = _interopRequireDefault(_ja);

var _ja3 = __webpack_require__(1388);

var _ja4 = _interopRequireDefault(_ja3);

var _localeData = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _localeData.setTranslations)(_ja4.default);
(0, _reactIntl.addLocaleData)(_ja2.default);

/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ja=t())}(this,function(){"use strict";return[{locale:"ja",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},"month-short":{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},"day-short":{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"時",relative:{0:"1 時間以内"},relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},"hour-short":{displayName:"時",relative:{0:"1 時間以内"},relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},minute:{displayName:"分",relative:{0:"1 分以内"},relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},"minute-short":{displayName:"分",relative:{0:"1 分以内"},relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},second:{displayName:"秒",relative:{0:"今"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"今"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}}]});


/***/ }),

/***/ 1388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ja = __webpack_require__(1389);

var _ja2 = _interopRequireDefault(_ja);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ja2.default;

/***/ }),

/***/ 1389:
/***/ (function(module, exports) {

module.exports = {"1-to-1 Projects":"1-to-1プロジェクト","99nonprofits":"99nonprofits","API integrations":"API","About":"会社概要","Account settings":"アカウント設定","Affiliates":"アフィリエイト","Agencies":"Agencies","Become a designer":"デザイナー","Blog":"ブログ","Book cover design":"書籍表紙デザイン","Brand guide":"ブランドガイドライン","Browse all categories":"カテゴリ一覧","Browse categories":"カテゴリ一覧","Browse contests":"コンペ一覧","Business card":"名刺","Careers":"キャリア","Categories":"カテゴリ","Community":"コミュニティ","Company":"会社情報","Contact":"お問い合わせ","Contests":"コンペ","Credits":"クレジット","Design consultation":"デザイン相談","Design contests":"デザインコンペ","Design services":"デザインサービス","Designer resources":"デザイナーガイド","Designers":"デザイナー","Discover":"ディスカバー","Discover inspiration":"ディスカバーページ","Earnings":"報酬","Featured partners":"注目パートナー社","Find a designer":"デザイナーを探す","Forum":"フォーラム","Get a design":"デザインを依頼する","Getting started":"はじめに","Help":"ヘルプ","Help Center":"ヘルプセンター","Home":"ホーム","How it works":"ご利用の流れ","Imprint":"Imprint","In the media":"メディア掲載","Log in":"ログイン","Log out":"ログアウト","Logo design":"ロゴデザイン","Logo ideas":"ロゴのアイデア","Mark all as read":"全て既読にする","NDAs":"秘密保持契約（NDA）","Notifications":"お知らせ","Packaging design":"パッケージデザイン","Press releases":"プレスリリース一覧","Pricing":"料金","Privacy":"プライバシーポリシー","Private messages":"Private messages","Profile":"プロフィール","Projects":"プロジェクト","Recent winners":"最近の優勝者","Resources":"リソース","See all messages":"すべてのメッセージを見る","See all notifications":"すべてのお知らせを表示","Settings":"設定","Support":"サポート","T-shirt design":"Tシャツデザイン","T-shirt ideas":"Tシャツのアイデア","Team":"スタッフ","Terms":"利用規約","Testimonials":"お客様の声","Transactions":"取引明細","Web page design":"ウェブデザイン","Your clients":"クライアント","Your work":"お仕事管理","{lang}":"{lang}","{phone}":"{phone}","© 99designs":"© 99designs","An error occured and we were unable to load your messages.":"エラーが発生しメッセージを読み込むことができませんでした。","Enable browser notificatons?":"ブラウザ通知を受信しますか？","Get updates on your device, even when 99designs is closed.":"99designsのサイトがアクティブでない状態でもブラウザからお知らせ通知を受信する事ができます。","Messages":"メッセージ","No notifications found.":"お知らせが見つかりませんでした。","No thanks":"いいえ","notification.body":"お知らせ通知を有効にしました！アカウント設定ページからブラウザ通知をカスタマイズすることができます。","notification.title":"99designsからのお知らせ","Please log in to view your messages":"メッセージを読むにはログインが必要です","To start a message, find a designer and go to the envelope on their profile.":"メッセージを開始するには、デザイナーを見つけてプロフィールページにある封筒をクリックします。","Unable to load messages":"メッセージを読み込むことができません。","When you receive new messages, you will see them here.":"新しいメッセージが届いたら、ここに表示されます。","Yes please":"はい","You have no private messages":"プライベートメッセージはありません"}

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setTranslations = setTranslations;
exports.getTranslations = getTranslations;
var translations = {};

function setTranslations(t) {
    Object.assign(translations, t);
}

function getTranslations() {
    return translations;
}

/***/ })

},[1385]);


// WEBPACK FOOTER //
// locale-data/ja-1b171204c43e7eb934ab.js